import { createContext } from 'react';

import { Event, EventQueryResults } from '@totem/types/events';

interface Context {
  loading: boolean;
  eventData: EventQueryResults;
  totalRecords: number;
  onAction?: (action: string, event: Event) => void;
  historyOnly: boolean;
  setHistoryOnly: (historyOnly: boolean) => void;
}

export default createContext<Context>({
  loading: false,
  eventData: null,
  totalRecords: 0,
  onAction: null,
  historyOnly: false,
  setHistoryOnly: () => {},
});
